import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import AuthShell, { AuthLabel, AuthInput, AuthPrimaryButton, AuthErrorLine, formatApiErrorDetail } from "../components/AuthShell";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err?.response?.data?.detail) || "Something went wrong");
    } finally { setLoading(false); }
  };

  return (
    <AuthShell
      eyebrow="CUSTOMER · RESET PASSWORD"
      title="Forgot your password?"
      subtitle="Enter your email and we'll send you a reset link."
      footer={
        <p className="font-mono text-[10px] tracking-[0.3em] text-off-white/60">
          <Link to="/login" className="text-rose hover:text-off-white">← BACK TO SIGN IN</Link>
        </p>
      }
    >
      {sent ? (
        <div className="mt-10 border border-rose/30 bg-rose/5 p-6 text-center" data-testid="forgot-success">
          <p className="font-mono text-[10px] tracking-[0.3em] text-rose mb-2">// EMAIL SENT</p>
          <p className="text-off-white/80 text-sm">If an account exists for that email, a reset link is on its way. Check your inbox.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-10 space-y-4" data-testid="forgot-form">
          <div>
            <AuthLabel>EMAIL</AuthLabel>
            <AuthInput type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus required data-testid="forgot-email-input" />
          </div>
          <AuthErrorLine error={error} />
          <AuthPrimaryButton type="submit" loading={loading} disabled={!email} data-testid="forgot-submit-btn">
            SEND RESET LINK <ArrowRight size={16} />
          </AuthPrimaryButton>
        </form>
      )}
    </AuthShell>
  );
};

export default ForgotPassword;
